import { render, staticRenderFns } from "./consignmentGoods.vue?vue&type=template&id=5c06fb80&"
import script from "./consignmentGoods.vue?vue&type=script&lang=js&"
export * from "./consignmentGoods.vue?vue&type=script&lang=js&"
import style0 from "./consignmentGoods.vue?vue&type=style&index=0&id=5c06fb80&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports